var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 28,
    fill: "#112240"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24, 20)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 20,
    rx: 32,
    ry: 10,
    fill: "#a855f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,20 v20 c0,5.5 14.3,10 32,10 s32,-4.5 32,-10 v-20",
    fill: "#7c3aed"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 40,
    rx: 32,
    ry: 10,
    fill: "#9333ea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,40 v22 c0,5.5 14.3,10 32,10 s32,-4.5 32,-10 v-22",
    fill: "#6d28d9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 62,
    rx: 32,
    ry: 10,
    fill: "#8b5cf6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 68,
    r: 14,
    fill: "#10b981",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 78,
    x2: 80,
    y2: 90,
    stroke: "#10b981",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRag);
export default __webpack_public_path__ + "static/media/rag.2fcb1387e7ec942331f8d53ec7418085.svg";
export { ForwardRef as ReactComponent };